// src/components/Common/Moodle/Learning/MoodleLearningProgress.ts

export type MoodleModuleLike = {
  id?: string | number;
  visible?: boolean;
  uservisible?: boolean;
  modname?: string;
  completiondata?: {
    hascompletion?: boolean;
    isoverallcomplete?: boolean;
  };
};

export type MoodleSectionLike = {
  id?: string | number;
  modules?: MoodleModuleLike[];
};

export type RequiredProgressResult = {
  completed: number;
  total: number;
  percent: number;
  requiredItemIds: string[];
  completedRequiredItemIds: string[];
};

export function computeRequiredProgressFromSections(
  sections: MoodleSectionLike[] | undefined | null,
  locallyCompletedIds?: Set<string>
): RequiredProgressResult {
  const safeSections = Array.isArray(sections) ? sections : [];
  const localSet = locallyCompletedIds ?? new Set<string>();

  const required: string[] = [];
  const completedRequired: string[] = [];

  safeSections.forEach((section) => {
    const modules = Array.isArray(section?.modules) ? section.modules : [];

    modules
      .filter((mod) => mod?.visible !== false)
      .filter((mod) => mod?.uservisible !== false)
      .filter((mod) => mod?.modname !== 'label')
      .forEach((mod) => {
        const id = String(mod?.id ?? '');
        if (!id) return;

        const isRequired = !!mod?.completiondata?.hascompletion;
        if (!isRequired) return;

        required.push(id);

        const backendComplete = !!mod?.completiondata?.isoverallcomplete;
        const localComplete = localSet.has(id);

        if (backendComplete || localComplete) {
          completedRequired.push(id);
        }
      });
  });

  const total = required.length;
  const completed = completedRequired.length;
  const percent = total > 0 ? Math.round((completed / total) * 100) : 0;

  return {
    completed,
    total,
    percent,
    requiredItemIds: required,
    completedRequiredItemIds: completedRequired,
  };
}